import axios, { AxiosRequestConfig } from "axios";
import moment from 'moment';
import 'moment/locale/id';

export const searchFunc = (data: any, query: string, key: string) => {
  let res = data.filter((text: any) => text[key].toLowerCase().includes(query.toLowerCase()));
  return res;
};

export const getDecryptedUser = () => {
  const localStorage = window.localStorage.getItem('@wadashboardsandboxdata') ?? undefined;
  return JSON.parse(localStorage ?? '{}');
};

export const isAuthenticated = () => {
  const moment = require('moment');
  let isAuth = false;
  const decrypt = getDecryptedUser();
  if (decrypt && decrypt.Auth) {
    const auth = JSON.parse(decrypt.Auth);
    if (auth && auth.data && auth.data.expired_date) {
      let exp: string = auth.data.expired_date;
      let date_string = exp.split('.');
      if (date_string.length === 2) {
        let exp_date = moment(date_string[0]);
        isAuth = exp_date.isAfter(new Date());
      }
    }
  }

  return isAuth;
};

export const getToken = () => {
  let token = '';
  const decrypt = getDecryptedUser();

  if (decrypt && decrypt.Auth) {
    const auth = JSON.parse(decrypt.Auth);
    if (auth && auth.data && auth.data.data.token) {
      token = auth.data.data.token;
    }
  } else {
    window.location.pathname = '/login';
  }

  return token;
};

export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export const convertToValidDate = (val: any) => {
  let parts = val.split('-');
  // let mydate = new Date(parts[2], parts[1] - 1, parts[0]);
  let cons = parts[2] + '-' + parts[1] + '-' + parts[0];
  return cons;
};

export const formatCurrency = (money: number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(money);
};

export const objectToParams = (obj: any) => {
  let str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
};

export const removeAllState = async () => {
  return await localStorage.removeItem('@wadashboardsandboxdata');
};

export const numberWithCommas = (x: number) => {
  return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(".00","");
};

export const formatDate = (date: string) => {
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

export const formatDateToDDMMMYYYY = (dateInput: string | Date | null | undefined, includeTime: boolean = false, includeSeconds: boolean = true): string => {
  if (!dateInput) {
    return 'N/A';
  }

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun',
    'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'
  ];

  const m = moment(dateInput);
  if (!m.isValid()) {
    return 'Invalid Date';
  }

  const day = m.date().toString().padStart(2, '0');
  const month = months[m.month()];
  const year = m.year();

  let formattedDate = `${day} ${month} ${year}`;

  if (includeTime) {
    const hours = m.hours().toString().padStart(2, '0');
    const minutes = m.minutes().toString().padStart(2, '0');

    formattedDate += ` ${hours}:${minutes}`;

    if (includeSeconds) {
      const seconds = m.seconds().toString().padStart(2, '0');
      formattedDate += `:${seconds}`;
    }
  }

  return formattedDate;
};

export function titleCase(str: string) {
  let format = /[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/;
  let splitStr = str.split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    if (!format.test(splitStr[i].charAt(0))) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1).toLowerCase();
    } else {
      splitStr[i] = splitStr[i].charAt(0) + splitStr[i].substring(1);
    }
  }
  return splitStr.join(' ');
}

export function onlyLettersAndSpaces(str: string) {
  return /^[A-Za-z\s]*$/.test(str);
}

export function onlyAlphaNumeric(str: string) {
  return /^[A-Za-z0-9_]+$/.test(str);
}

export const urlExists = (url: string) => {
  let http = new XMLHttpRequest();
  http.open('HEAD', url, false);
  http.send();
  if (http.status !== 404) {
    return true;
  } else {
    return false;
  }
};

export const downloadOrderAsExcel = async ({
  token,
  startOrderDate,
  finishOrderDate,
  status,
  merchantId,
  isService = false,
  sort_by = 'date',
  sort_direction = 'asc',
  setDownload,
  setDownloadProgress,
}:{
  token: String,
  startOrderDate: String | null,
  finishOrderDate: String | null,
  status: String,
  merchantId: number,
  isService?: boolean,
  sort_by?: String,
  sort_direction?: String,
  setDownload?: (isDownloading: boolean) => void,
  setDownloadProgress?: (percentage: number) => void,
}) => {
  if(setDownload) setDownload(true);
  const headers = {
    'Content-Type': 'blob',
    api_key: `${process.env.REACT_APP_API_KEY}`,
    Authorization: `Bearer ${token ?? ''}`,
  };

  let url = `/api/v1/orders/export?${startOrderDate ? `&start_date=${startOrderDate}` : ''}${finishOrderDate ? `&finish_date=${finishOrderDate}` : ''}&status=${status}&merchant_id=${merchantId}&is_service=${isService}&sort_by=${sort_by}&sort_direction=${sort_direction}`;

  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}${url}`,
    responseType: 'arraybuffer',
    headers,
    onDownloadProgress: (progressEvent: any) => {
      let percentage = Math.round((progressEvent?.loaded * 100) / progressEvent?.total);
      if(setDownloadProgress) setDownloadProgress(percentage);
    },
  };

  try {
    const response = await axios(config);
    const outputFilename = `orders ${startOrderDate} ${finishOrderDate}.xlsx`;
    // If you want to download file automatically using link attribute.
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
  } catch(error) {
    alert(error);
  } finally {
    if(setDownload) setDownload(false);
  }
}

/**
 * Mengenkripsi ID menggunakan XOR salted cipher dan Base64.
 * Hasilnya akan URL-safe agar aman digunakan di query parameter.
 */
export const encrypt = (rawId: string): string => {

  if(!process.env.REACT_APP_SALT) throw new Error("encryption error: salt is undefined");

  const salt = process.env.REACT_APP_SALT;

  // 1. Lakukan XOR antara ID asli dengan Salt
  let encrypted = "";
  for (let i = 0; i < rawId.length; i++) {
    encrypted += String.fromCharCode(
      rawId.charCodeAt(i) ^ salt.charCodeAt(i % salt.length)
    );
  }

  // 2. Encode hasil XOR ke Base64
  const base64 = btoa(encrypted);

  // 3. Ubah menjadi URL-safe Base64 (menghindari karakter +, /, dan =)
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

export const customStyles = {
  headRow: {
    style: {
      backgroundColor: '#F8FAFC',
      borderTopWidth: '1px',
      borderTopColor: '#E2E8F0',
      borderTopStyle: 'solid',
      borderBottomWidth: '1px',
      borderBottomColor: '#E2E8F0',
      borderBottomStyle: 'solid',
      minHeight: '52px',
    },
  },
  headCells: {
    style: {
      fontWeight: 600,
      fontSize: '13px',
      color: '#475569',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  rows: {
    style: {
      fontSize: '14px',
      color: '#1E293B',
      minHeight: '64px',
      borderBottomColor: '#F1F5F9',
      borderBottomStyle: 'solid',
      borderBottomWidth: '1px',
      '&:not(:last-of-type)': {
        borderBottomColor: '#F1F5F9',
      },
      '&:hover': {
        backgroundColor: '#F8FAFC',
        transition: 'all 0.2s ease',
      },
    },
  },
  cells: {
    style: {
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
};

export const getPasswordStrength = (password: string) => {
  let score = 0;
  if (!password) return { score: 0, label: '', color: '' };
  if (password.length >= 8) score += 1;
  if (password.match(/[a-z]/) && password.match(/[A-Z]/)) score += 1;
  if (password.match(/\d/)) score += 1;
  if (password.match(/[^a-zA-Z\d]/)) score += 1;
  switch(score) {
    case 0: case 1: return { score, label: 'Lemah', color: '#ef4444' };
    case 2: return { score, label: 'Sedang', color: '#f59e0b' };
    case 3: return { score, label: 'Kuat', color: '#10b981' };
    case 4: return { score, label: 'Sangat Kuat', color: '#059669' };
    default: return { score: 0, label: '', color: '' };
  }
};

export const formatRelativeTime = (date: string | Date) => {
  const m = moment(date).locale('id');
  const diffInSeconds = moment().diff(m, 'seconds');
  if (diffInSeconds < 60 && diffInSeconds >= 0) {
    return 'Baru saja';
  }
  return m.fromNow();
};